import { panelSnapshotPosts } from './PanelSnapshotPosts';

const collageSnapshot = {
    id: 'cGFuZWw6NWQ4ZDEwZWRjYmU5OTMwZTE3OGQ3M2Vl',
    partnerId: 349,
    clientId: 7101,
    name: 'Collage',
    description: '',
    publishTier: null,
    theme: {
        typography: {
            color: '',
            size: null,
            sizeLiteral: null,
            primary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
            secondary: {
                family: '',
                url: '',
                color: '',
                size: null,
                sizeLiteral: null,
                samId: null,
                name: null,
                description: null,
                subFamily: null,
                weight: null,
                style: null,
            },
        },
        background: {
            url: '',
            size: '',
            repeat: '',
            color: '',
            position: '',
        },
        colorPalette: {
            type: '',
            solid: '',
            highlight: null,
            monochrome: {
                startColor: '',
                endOffset: null,
            },
            colorBlend: {
                startColor: '',
                endColor: '',
            },
            ranked: {
                colors: null,
                contrast: null,
            },
        },
    },
    storyboard: {
        id: 'c3Rvcnlib2FyZDo1ZDhhOTIzODM1YmYyNzA5MDNiYzA0YzM=',
        name: 'legz - panel snapshots',
        pageNumber: {
            enabled: false,
            color: 'white',
            size: 10,
            alignment: 'right',
            showTotal: null,
        },
        watermark: {
            panelIndex: null,
            watermarkRendered: null,
            imageUrl: null,
        },
    },
    scene: {
        id: 'c2NlbmU6NWQ4ZDEwZWRjYmU5OTMwZTE3OGQ3M2Vk',
        name: 'Scene 23',
        duration: 0,
        disabled: false,
        theme: null,
        sceneTransition: null,
    },
    widget: {
        children: [
            {
                children: null,
                id: '1',
                name: 'collage',
                type: 'postsCollage',
                css: null,
                js: null,
                options: {
                    player: {
                        playing: false,
                        duration: 6,
                    },
                    labelEnable: true,
                    labelTimeRangeSize: 16,
                    labelTimeRangeEnabled: false,
                    labelTimeRangeFormat: 'Pretty Time',
                    animationLength: 1000,
                    animationDelay: 0,
                    animationType: 'fade',
                    animationEnabled: false,
                    animationVariation: 6,
                    widgetOrientation: 'landscape',
                    opacity: 100,
                    zIndex: 0,
                    locked: false,
                    sort: 'auto',
                    percentChangeFormat: '1k',
                    metricTimeRoundSeconds: false,
                    fontFamilySecondary: null,
                    fontFamilyPrimary: null,
                    fontSize: null,
                    colorFont: null,
                    showSocialColors: true,
                    metricThreshold: null,
                    showFullTimePeriod: false,
                    textFormat: '',
                    useThemeColor: false,
                    useThemeImage: false,
                    useThemeEmail: false,
                    themeEmailSize: 20,
                    themeImagePosition: null,
                    themeImageOpacity: 100,
                    themeImageCircleMask: true,
                    themeImageSize: 100,
                    barChartScale: 100,
                    showPostTextOverlayAsGradient: false,
                    classOverrides: {
                        postText: {
                            default: 'p-reset pr-2 pl-2 pt-0',
                        },
                        postInner: {
                            default: 'between',
                        },
                        metaGroup: {
                            default: 'p-reset pb-2 pt-1 pl-2 pr-2',
                        },
                        userGroup: {
                            default: 'no-grow p-reset pb-2 pr-2 pl-2 pt-1',
                        },
                    },
                    postVersion: 2,
                    zeroFill: false,
                    zeroKill: false,
                    autoSizeWords: false,
                    invertDataSet: false,
                    showAdsMetrics: true,
                    showImageStyles: true,
                    imageFiltersOpen: true,
                    imageFilterBlur: false,
                    imageFilterBrightness: false,
                    imageFilterContrast: false,
                    imageFilterGrayscale: false,
                    imageFilterSaturate: false,
                    imageFilterHueRotate: false,
                    imageFilterOpacity: false,
                    imageFilterInvert: false,
                    imageFilterSepia: false,
                    imageFilterBlurValue: 0,
                    imageFilterBrightnessValue: 100,
                    imageFilterContrastValue: 100,
                    imageFilterGrayscaleValue: 0,
                    imageFilterSaturateValue: 100,
                    imageFilterHueRotateValue: 0,
                    imageFilterOpacityValue: 100,
                    imageFilterInvertValue: 0,
                    imageFilterSepiaValue: 0,
                    imageBlendMode: null,
                    imageSecondaryBlendMode: '',
                    imageBlendColor: 'rgba(0,0,0,.0)',
                    imageSecondaryBlendColor: '',
                    presetImageFilters: '',
                    imageTextColor: '#FFF',
                    postImageTextSize: 10,
                    imagePostLineClamp: true,
                    imagePostLineClampValue: 3,
                    imagePostHideText: true,
                    imageFaceDetection: false,
                    hashtagTextColor: '',
                    hashtagBackgroundColor: '',
                    mentionTextColor: '',
                    mentionBackgroundColor: '',
                    urlTextColor: '',
                    urlBackgroundColor: '',
                    showTextEntityUrls: false,
                    showEngagementMetrics: true,
                    engagementMetricsSize: 20,
                    engagementMetricsPosition: 'bottom_left',
                    adsMetricsSize: 30,
                    showTextStyles: false,
                    showText: true,
                    textOnlyColor: '#FFF',
                    postTextOnlySize: 10,
                    postLineClamp: true,
                    postLineClampValue: 3,
                    textFitMin: 20,
                    showPostTextOverlay: false,
                    showUserGroup: true,
                    showUserAvatar: true,
                    showUserName: true,
                    showUserScreenName: true,
                    userGroupIconSize: 10,
                    userGroupAvatarSize: 12,
                    userGroupNameSize: 17,
                    userGroupScreenNameSize: 12,
                    userGroupPosition: 'top',
                    userGroupGradientColor: 'rgba(0,0,0,.3)',
                    userGroupGradientEnabled: false,
                    userGroupGradientDirection: 'topToBottom',
                    showTimeStamp: false,
                    timeStampSize: 15,
                    timeStampFormat: 'timeAgo',
                    endianTime: 'D MMM YYYY, h:mm a',
                    textOnlyBackgroundColor: '',
                    textOnlyTextFormat: 'fit',
                    textOnlyTeleprompterSpeed: 50,
                    postImageTextFormat: 'fit',
                    postImageTeleprompterSpeed: 50,
                    imageBackgroundSize: 'cover',
                    showZeroEngagementValues: false,
                    maxCharacters: 180,
                    teleprompterSpeed: 50,
                    userGroupLayoutType: 'a',
                    postCompositionType: 'a',
                    socialIconBgColor: false,
                    customFields: {
                        fieldId: '',
                        size: 12,
                    },
                    reviews: {
                        enabled: false,
                        title: {
                            enabled: true,
                            color: '',
                            size: 17,
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 2,
                                },
                                fit: {
                                    min: 10,
                                    max: 400,
                                },
                            },
                        },
                        rating: {
                            enabled: true,
                            filledColor: '',
                            emptyColor: '',
                            size: 12,
                        },
                        product: {
                            enabled: true,
                            color: '',
                            size: 9,
                        },
                        message: {
                            enabled: true,
                            size: 13,
                            color: '',
                            format: {
                                type: 'clamp',
                                clamp: {
                                    enabled: true,
                                    lines: 5,
                                },
                                fit: {
                                    min: 20,
                                    max: 400,
                                },
                            },
                        },
                        domain: {
                            enabled: true,
                            color: '',
                            size: 9,
                        },
                    },
                    smartSize: {
                        enabled: true,
                        mode: 'responsive',
                        size: 'xl',
                    },
                    postComposition: 'a',
                    postTemplate: 'collage',
                    postTransition: 'scale',
                    userGroupEffect: 'bottom',
                    theme: 'primary',
                    showSentiment: true,
                    portrait: {
                        widgetOrientation: 'portrait',
                    },
                    showIconInUserGroup: true,
                    smartSizeCompositions: {
                        baseline: {
                            postTextOnlySize: 20,
                            userGroupIconSize: 10,
                            userGroupNameSize: 17,
                            userGroupScreenNameSize: 12,
                            userGroupAvatarSize: 12,
                            engagementMetricsSize: 20,
                        },
                        optionDefaults: {
                            classOverrides: {
                                postText: {
                                    default: 'p-reset pr-2 pl-2 pt-0',
                                },
                                postInner: {
                                    default: 'between',
                                },
                                metaGroup: {
                                    default: 'p-reset pb-2 pt-1 pl-2 pr-2',
                                },
                                userGroup: {
                                    default: 'no-grow p-reset pb-2 pr-2 pl-2 pt-1',
                                },
                            },
                        },
                        breakpoints: {
                            m: {
                                options: {
                                    classOverrides: {
                                        postText: {
                                            default: 'p-reset pr-1 pl-1 pt-0',
                                        },
                                        postInner: {
                                            default: 'between',
                                        },
                                        metaGroup: {
                                            default: 'p-reset pb-1 pt-05 pl-1 pr-1',
                                        },
                                        userGroup: {
                                            default: 'no-grow p-reset pb-1 pr-1 pl-1 pt-05',
                                        },
                                    },
                                },
                            },
                            s: {
                                options: {
                                    classOverrides: {
                                        postText: {
                                            default: 'p-reset pr-05 pl-05 pt-0',
                                        },
                                        postInner: {
                                            default: 'between',
                                        },
                                        metaGroup: {
                                            default: 'p-reset pb-05 pt-05 pl-05 pr-05',
                                        },
                                        userGroup: {
                                            default: 'no-grow p-reset pb-05 pr-05 pl-05 pt-05',
                                        },
                                    },
                                },
                            },
                            xs: {
                                options: {
                                    classOverrides: {
                                        postText: {
                                            default: 'p-reset pr-05 pl-05 pt-0',
                                        },
                                        postInner: {
                                            default: 'between',
                                        },
                                        metaGroup: {
                                            default: 'p-reset pb-05 pt-05 pl-05 pr-05',
                                        },
                                        userGroup: {
                                            default: 'no-grow p-reset pb-05 pr-05 pl-05 pt-05',
                                        },
                                    },
                                },
                            },
                        },
                    },
                },
                userAssetContentUrl: null,
                postRequests: [
                    {
                        sources: [
                            {
                                type: 'posts',
                                id: {
                                    source: 'REPORTING',
                                    reportingEngine: 'LISTENING',
                                    report: 'SPRINKSIGHTS',
                                    pageSize: '10',
                                    sorts: [
                                        {
                                            order: 'DESC',
                                            heading: 'REACH_COUNT',
                                        },
                                    ],
                                    includeFaceDetection: false,
                                    timePeriod: {
                                        timeZone: 'America/Los_Angeles',
                                        key: 'last_7_days',
                                        duration: 1,
                                        startTime: 1569481200000,
                                        endTime: 1569567599999,
                                    },
                                    filters: [
                                        {
                                            dimensionName: 'TOPIC_GROUP_IDS',
                                            filterType: 'IN',
                                            values: ['5a00b9e4e4b082264ab84227'],
                                        },
                                    ],
                                    showInReplyToPost: false,
                                    projections: [],
                                    groupBys: [],
                                },
                                options: {
                                    count: 200,
                                    imagePreload: false,
                                    removeDuplicates: true,
                                    includeFaceDetection: false,
                                    shufflePosts: false,
                                },
                                data: [
                                    {
                                        messageType: 2,
                                        accountId: 999998,
                                        snMsgId: '1176537936575258627',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569343477754,
                                        permalink:
                                            'https://twitter.com/show/status/1176537936575258627',
                                        message:
                                            "In honor of Sprinklr's 10th birthday today, I'm also celebrating the 10lbs I lost from riding my bike to work! #sprinklr10 #sprinklrlife #bikelife https://t.co/dKrY1ueh6M https://t.co/yR4b3ShAwt",
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [147, 170],
                                                    url: 'https://t.co/dKrY1ueh6M',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [171, 194],
                                                    url: 'https://t.co/yR4b3ShAwt',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [111, 122],
                                                    hashtag: 'sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [123, 136],
                                                    hashtag: 'sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [137, 146],
                                                    hashtag: 'bikelife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'Austin, TX',
                                            gender: null,
                                            snId: '24314460',
                                            name: 'Jake Trigg',
                                            screenName: 'ATXatLarge',
                                            email: null,
                                            bio:
                                                "Product, Program and Project Manager for high-growth software startups. I'm a click-counter, and focus on empowering others and being of service.",
                                            following: 214,
                                            followers: 85,
                                            favCount: 37,
                                            statusCount: 534,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/ATXatLarge',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/1254840369/ATX_Large-logo_normal.png',
                                            createdTime: 1236999001000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5bc4be8ae4b03a19f57fb6bb',
                                            participationIndex: 0,
                                            influencerIndex: 38,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [281513],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Austin, Texas, United States',
                                            lat: 30.26715,
                                            lon: -97.74306,
                                            additional: {
                                                country: 'United States',
                                                state: 'Texas',
                                                code: 'US',
                                                state_code: 'TX',
                                                city: 'Austin',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[0].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 194,
                                            numRetweets: 1,
                                            reachCount: 41730,
                                            numLikes: 17,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 83,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 17,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1176342792685019136',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569296951825,
                                        permalink:
                                            'https://twitter.com/show/status/1176342792685019136',
                                        message:
                                            'Time to fly into a new decade! 😂😂 ✈️ #Sprinklr10 #SprinklrLife \n\nHappy Birthday @Sprinklr! https://t.co/NtbSzu2sNQ',
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [82, 91],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [93, 116],
                                                    url: 'https://t.co/NtbSzu2sNQ',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [39, 50],
                                                    hashtag: 'Sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [51, 64],
                                                    hashtag: 'SprinklrLife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'India',
                                            gender: 'M',
                                            snId: '206077671',
                                            name: 'Akshit Dhumal',
                                            screenName: 'akshitdhumal',
                                            email: null,
                                            bio:
                                                'Whatever you do, don’t be another brick in the wall!',
                                            following: 1710,
                                            followers: 822,
                                            favCount: 1336,
                                            statusCount: 2252,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/akshitdhumal',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/1175464468802703360/eNKo60Tp_normal.jpg',
                                            createdTime: 1287730322000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '54368820e4b093569d4cbe68',
                                            participationIndex: 0,
                                            influencerIndex: 55,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Bengaluru South, India',
                                            lat: 20,
                                            lon: 77,
                                            additional: {
                                                country: 'India',
                                                code: 'IN',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[1].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 116,
                                            numRetweets: 3,
                                            reachCount: 39126,
                                            numLikes: 10,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 822,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 10,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {
                                            eS: [
                                                {
                                                    title: 'Company',
                                                    pol: 'neutral',
                                                    sc: 1,
                                                    labels: ['time'],
                                                },
                                            ],
                                        },
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1176569974053330945',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569351116084,
                                        permalink:
                                            'https://twitter.com/show/status/1176569974053330945',
                                        message:
                                            'Home office celebrations for #Sprinklr10 in full effect with my Administrative Assistant, Vincenzo 🥳 @Sprinklr #SprinklrLife https://t.co/HR2bEdgfun',
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [102, 111],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [126, 149],
                                                    url: 'https://t.co/HR2bEdgfun',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [29, 40],
                                                    hashtag: 'Sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [112, 125],
                                                    hashtag: 'SprinklrLife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: '',
                                            gender: null,
                                            snId: '1110586199947792384',
                                            name: 'Janelle Panuccio',
                                            screenName: 'JanellePanuccio',
                                            email: null,
                                            bio: 'Account Executive @Sprinklr  #SprinklrLife',
                                            following: 92,
                                            followers: 34,
                                            favCount: 135,
                                            statusCount: 61,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/JanellePanuccio',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=https://pbs.twimg.com/profile_images/1154086173876391937/yyRxkV_9_normal.jpg',
                                            createdTime: 1553619358000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5c9e8156e4b0f0b88c295159',
                                            participationIndex: 0,
                                            influencerIndex: 0,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Colonial Park, PA',
                                            lat: 0,
                                            lon: 0,
                                            additional: {
                                                country: 'United States',
                                                code: 'US',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[2].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 149,
                                            numRetweets: 2,
                                            reachCount: 35954,
                                            numLikes: 15,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 34,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 15,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1175463499830452225',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569087312072,
                                        permalink:
                                            'https://twitter.com/show/status/1175463499830452225',
                                        message:
                                            "It's going to be a decade of:\n\n- It's ok\n- Sprinkle, don't shout\n- Fix it, don't complain\n- Never, ever give up\n- Passionately, genuinely care\n\n@Tool  influenced riff for the Best Social Media Management Tool out there 😎 \nHappy Birthday, @Sprinklr 🎂\n\n#sprinklrlife #sprinklr10 https://t.co/S1MzpXqQpT",
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [144, 149],
                                                    screenName: 'Tool',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [239, 248],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [279, 302],
                                                    url: 'https://t.co/S1MzpXqQpT',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [253, 266],
                                                    hashtag: 'sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [267, 278],
                                                    hashtag: 'sprinklr10',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'India',
                                            gender: 'M',
                                            snId: '206077671',
                                            name: 'Akshit Dhumal',
                                            screenName: 'akshitdhumal',
                                            email: null,
                                            bio:
                                                'Whatever you do, don’t be another brick in the wall!',
                                            following: 1710,
                                            followers: 822,
                                            favCount: 1336,
                                            statusCount: 2252,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/akshitdhumal',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/1175464468802703360/eNKo60Tp_normal.jpg',
                                            createdTime: 1287730322000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '54368820e4b093569d4cbe68',
                                            participationIndex: 0,
                                            influencerIndex: 55,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'India',
                                            lat: 20,
                                            lon: 77,
                                            additional: {
                                                country: 'India',
                                                code: 'IN',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[3].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 302,
                                            numRetweets: 6,
                                            reachCount: 10337,
                                            numLikes: 19,
                                            numComments: 2,
                                            favoritesCount: 0,
                                            numFollowers: 822,
                                            replyCount: 2,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 19,
                                        numberOfShares: 0,
                                        numberOfComments: 2,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1176237159940067331',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569271767016,
                                        permalink:
                                            'https://twitter.com/show/status/1176237159940067331',
                                        message:
                                            "Super excited to celebrate 10 years of @Sprinklr. We were fearless,  humble, we didn't complain, we never gave up, and we passionately cared, and now WE'RE HEEEEEEEEERE. #sprinklr10 #sprinklrlife https://t.co/hHrKVmfYsS",
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [39, 48],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [196, 219],
                                                    url: 'https://t.co/hHrKVmfYsS',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [170, 181],
                                                    hashtag: 'sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [182, 195],
                                                    hashtag: 'sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'Brooklyn NY',
                                            gender: null,
                                            snId: '116590906',
                                            name: 'operasoul',
                                            screenName: 'opera_soul',
                                            email: null,
                                            bio:
                                                'christian. operasoul singer. communicator. developer. curator. brooklynite. culture lover. people first evangelist. passionate artist. @sprinklr',
                                            following: 431,
                                            followers: 269,
                                            favCount: 370,
                                            statusCount: 1675,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/opera_soul',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/3627774778/384ae7abc49dcbe1ebc0dd0708edba06_normal.jpeg',
                                            createdTime: 1266886755000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5a01a44ee4b0ba0b39d7d5a8',
                                            participationIndex: 0,
                                            influencerIndex: 47,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [281513],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Brooklyn, New York, United States',
                                            lat: 40.6501,
                                            lon: -73.94958,
                                            additional: {
                                                country: 'United States',
                                                state: 'New York',
                                                code: 'US',
                                                state_code: 'NY',
                                                city: 'Brooklyn',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[4].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 219,
                                            numRetweets: 3,
                                            reachCount: 7245,
                                            numLikes: 15,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 258,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 15,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1176207256792129536',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569264637550,
                                        permalink:
                                            'https://twitter.com/show/status/1176207256792129536',
                                        message:
                                            'Happy birthday @Sprinklr ❤️ 10 years of spreading happiness! Lots more to come 🥂 #Sprinklr10 #sprinklrlife https://t.co/n5HLimZWFb',
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [15, 24],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [108, 131],
                                                    url: 'https://t.co/n5HLimZWFb',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [82, 93],
                                                    hashtag: 'Sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [94, 107],
                                                    hashtag: 'sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: null,
                                            gender: null,
                                            snId: '3056220439',
                                            name: 'chandana_raja',
                                            screenName: 'chandana_raja',
                                            email: null,
                                            bio: null,
                                            following: 54,
                                            followers: 26,
                                            favCount: 14,
                                            statusCount: 23,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/chandana_raja',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/572383236718743552/NUyYUU_i_normal.jpeg',
                                            createdTime: 1425301381000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5bfcc266e4b08d2534caa219',
                                            participationIndex: 0,
                                            influencerIndex: 23,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [],
                                            accountsFollowingUser: [],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Unknown',
                                            lat: 0,
                                            lon: 0,
                                            additional: {
                                                code: 'UN',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[5].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 131,
                                            numRetweets: 2,
                                            reachCount: 5701,
                                            numLikes: 29,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 26,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 29,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1177268822471921664',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569517734531,
                                        permalink:
                                            'https://twitter.com/show/status/1177268822471921664',
                                        message:
                                            'We are ready to rep @Sprinklr at the Twitter Data Cup thank you @OfficialPartner @kimwu 🙏🏾 #sprinklrlife #Sprinklr10 #TwitterDataCup https://t.co/AfP7IofyP6',
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [20, 29],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [64, 80],
                                                    screenName: 'OfficialPartner',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [81, 87],
                                                    screenName: 'kimwu',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [135, 158],
                                                    url: 'https://t.co/AfP7IofyP6',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [93, 106],
                                                    hashtag: 'sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [107, 118],
                                                    hashtag: 'Sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [119, 134],
                                                    hashtag: 'TwitterDataCup',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'New York, NY',
                                            gender: null,
                                            snId: '568155833',
                                            name: 'Yoli Chisholm',
                                            screenName: 'yolichisholm',
                                            email: null,
                                            bio:
                                                'VP Marketing @sprinklr Author, Speaker, Tech Advisor, blockchain investor',
                                            following: 9087,
                                            followers: 5283,
                                            favCount: 527,
                                            statusCount: 12400,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/yolichisholm',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/556265079016931328/-J3ObhsZ_normal.jpeg',
                                            createdTime: 1335875105000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5446940fe4b07f01faeed06f',
                                            participationIndex: 0,
                                            influencerIndex: 0,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [],
                                            accountsFollowingUser: [281513, 308959],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'New York, United States',
                                            lat: 43.00035,
                                            lon: -75.4999,
                                            additional: {
                                                country: 'United States',
                                                state: 'New York',
                                                code: 'US',
                                                state_code: 'NY',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[6].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 158,
                                            reachCount: 5283,
                                            numLikes: 2,
                                            favoritesCount: 0,
                                            numFollowers: 5283,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 2,
                                        numberOfShares: 0,
                                        numberOfComments: 0,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {
                                            eS: [
                                                {
                                                    title: 'Company',
                                                    pol: 'neutral',
                                                    sc: 1,
                                                    labels: ['twitter'],
                                                },
                                            ],
                                        },
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1176609707664056320',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569360589315,
                                        permalink:
                                            'https://twitter.com/show/status/1176609707664056320',
                                        message:
                                            'Happy birthday @Sprinklr congratulations #sprinklrites for living that #Sprinklrlife #Sprinklr10 https://t.co/W8IQ93qISP',
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [15, 24],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [97, 120],
                                                    url: 'https://t.co/W8IQ93qISP',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [41, 54],
                                                    hashtag: 'sprinklrites',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [71, 84],
                                                    hashtag: 'Sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [85, 96],
                                                    hashtag: 'Sprinklr10',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'New York, NY',
                                            gender: null,
                                            snId: '568155833',
                                            name: 'Yoli Chisholm',
                                            screenName: 'yolichisholm',
                                            email: null,
                                            bio:
                                                'VP Marketing @sprinklr Author, Speaker, Tech Advisor, blockchain investor',
                                            following: 9087,
                                            followers: 5283,
                                            favCount: 527,
                                            statusCount: 12400,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/yolichisholm',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/556265079016931328/-J3ObhsZ_normal.jpeg',
                                            createdTime: 1335875105000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5446940fe4b07f01faeed06f',
                                            participationIndex: 0,
                                            influencerIndex: 0,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [],
                                            accountsFollowingUser: [281513, 308959],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'New York, United States',
                                            lat: 43.00035,
                                            lon: -75.4999,
                                            additional: {
                                                country: 'United States',
                                                state: 'New York',
                                                code: 'US',
                                                state_code: 'NY',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[7].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 120,
                                            reachCount: 5282,
                                            numLikes: 7,
                                            numComments: 1,
                                            favoritesCount: 0,
                                            numFollowers: 5282,
                                            replyCount: 1,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 7,
                                        numberOfShares: 0,
                                        numberOfComments: 1,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 2,
                                        accountId: 999998,
                                        snMsgId: '1176672788498788352',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569375628958,
                                        permalink:
                                            'https://twitter.com/show/status/1176672788498788352',
                                        message:
                                            '👀 Who are are these smiling folks #Sprinklr10 #Sprinklrlife https://t.co/ylGfVpzi8Y',
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [61, 84],
                                                    url: 'https://t.co/ylGfVpzi8Y',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [35, 46],
                                                    hashtag: 'Sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [47, 60],
                                                    hashtag: 'Sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'New York, NY',
                                            gender: null,
                                            snId: '568155833',
                                            name: 'Yoli Chisholm',
                                            screenName: 'yolichisholm',
                                            email: null,
                                            bio:
                                                'VP Marketing @sprinklr Author, Speaker, Tech Advisor, blockchain investor',
                                            following: 9087,
                                            followers: 5283,
                                            favCount: 527,
                                            statusCount: 12400,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/yolichisholm',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=http://pbs.twimg.com/profile_images/556265079016931328/-J3ObhsZ_normal.jpeg',
                                            createdTime: 1335875105000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '5446940fe4b07f01faeed06f',
                                            participationIndex: 0,
                                            influencerIndex: 0,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [],
                                            accountsFollowingUser: [281513, 308959],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'New York, United States',
                                            lat: 43.00035,
                                            lon: -75.4999,
                                            additional: {
                                                country: 'United States',
                                                state: 'New York',
                                                code: 'US',
                                                state_code: 'NY',
                                            },
                                        },
                                        language: 'en',
                                        images: [
                                            {
                                                url: panelSnapshotPosts[8].url,
                                            },
                                        ],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 84,
                                            reachCount: 5281,
                                            numLikes: 9,
                                            favoritesCount: 0,
                                            numFollowers: 5282,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 9,
                                        numberOfShares: 0,
                                        numberOfComments: 0,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {},
                                        workflowProperties: {
                                            sentiment: 0,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                    {
                                        messageType: 4,
                                        accountId: 999998,
                                        snMsgId: '1176596118638972928',
                                        partnerId: 349,
                                        clientId: 7101,
                                        sourceType: 'LISTENING',
                                        sourceId: -1,
                                        snType: 'TWITTER',
                                        snCreatedTime: 1569357349439,
                                        permalink:
                                            'https://twitter.com/show/status/1176596118638972928',
                                        message:
                                            "We are humbled and gracious to work with our @Sprinklr Marketing and Dev teams to design the world's best enterprise website centered on Listen, Love and Learn! Go check it out! https://t.co/xNB96IziGa ❤️ Sprinklr Product Design Team 😊 #sprinklr10 #sprinklrlife",
                                        textEntities: {
                                            message: [
                                                {
                                                    indices: [45, 54],
                                                    screenName: 'Sprinklr',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [178, 201],
                                                    url: 'https://t.co/xNB96IziGa',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [237, 248],
                                                    hashtag: 'sprinklr10',
                                                    copiableEntity: false,
                                                },
                                                {
                                                    indices: [249, 262],
                                                    hashtag: 'sprinklrlife',
                                                    copiableEntity: false,
                                                },
                                            ],
                                        },
                                        senderProfile: {
                                            id: null,
                                            snType: 'TWITTER',
                                            age: 0,
                                            location: 'Portland, OR',
                                            gender: 'M',
                                            snId: '9198472',
                                            name: 'Ryan Parr',
                                            screenName: 'RyanParr',
                                            email: null,
                                            bio:
                                                'VP of Product Design ✏️ @Sprinklr • Artist, Coder, Vinyl Collector, Music Lover, digital Storyteller, App Creator @panictour • #design #ux #xd',
                                            following: 1938,
                                            followers: 567,
                                            favCount: 2327,
                                            statusCount: 6210,
                                            kloutScore: null,
                                            permalink: 'https://twitter.com/RyanParr',
                                            profileUrl: null,
                                            profileImgUrl:
                                                'https://thumb.sprinklr.com/?d=200x200&url=https://pbs.twimg.com/profile_images/553782694782328832/rqeTj8SB_normal.jpeg',
                                            createdTime: 1191282565000,
                                            modifiedTime: null,
                                            clientId: null,
                                            accountId: null,
                                            universalProfileId: '59024e7ae4b05ef49bdfb98c',
                                            participationIndex: 0,
                                            influencerIndex: 61,
                                            spamIndex: 0,
                                            spamFlag: null,
                                            delFlag: null,
                                            isBlocked: null,
                                            snCreatedTime: null,
                                            snModifiedTime: null,
                                            positivePosts: null,
                                            negativePosts: null,
                                            totalPosts: null,
                                            verified: false,
                                            accountsFollowedByUser: [
                                                173120,
                                                246354,
                                                244375,
                                                281513,
                                            ],
                                            accountsFollowingUser: [173120, 246354, 244375, 281513],
                                            accountsBlockingUser: [],
                                            accountsUnFollowingUser: [],
                                            accountsUnFollowedByUser: [],
                                        },
                                        location: {
                                            text: 'Portland, Oregon, United States',
                                            lat: 45.52345,
                                            lon: -122.67621,
                                            additional: {
                                                country: 'United States',
                                                state: 'Oregon',
                                                code: 'US',
                                                state_code: 'OR',
                                                city: 'Portland',
                                            },
                                        },
                                        language: 'en',
                                        images: [],
                                        videos: [],
                                        title: null,
                                        universalId: null,
                                        scheduledTime: null,
                                        status: null,
                                        accountIds: null,
                                        accountGroupIds: null,
                                        channelSpecificAdditionalProperties: null,
                                        snStats: {
                                            contentLength: 262,
                                            numRetweets: 2,
                                            reachCount: 1391,
                                            numLikes: 13,
                                            numComments: 2,
                                            favoritesCount: 0,
                                            numFollowers: 564,
                                            replyCount: 2,
                                        },
                                        projectionStats: null,
                                        numberOfLikes: 13,
                                        numberOfShares: 0,
                                        numberOfComments: 2,
                                        comments: null,
                                        itemName: null,
                                        itemRating: null,
                                        maxRating: null,
                                        domain: null,
                                        additionalInformation: {
                                            eS: [
                                                {
                                                    title: 'Company',
                                                    pol: 'neutral',
                                                    sc: 1,
                                                    labels: ['ign '],
                                                },
                                            ],
                                        },
                                        workflowProperties: {
                                            sentiment: 2,
                                            partnerCustomProperties: null,
                                            clientCustomProperties: null,
                                            customProperties: null,
                                            campaignId: null,
                                            tags: null,
                                            urlShortenerId: null,
                                        },
                                        additionalProjections: null,
                                        products: [],
                                        alertDetails: null,
                                        actualTweet: null,
                                        actualTweets: null,
                                        parentUniversalMessageKey: null,
                                        inReplyToPost: null,
                                        extraPostData: [],
                                        channelCustomProperties: null,
                                    },
                                ],
                            },
                        ],
                        format: {
                            type: 'buckets',
                            options: {
                                padding: 1,
                                buckets: {
                                    text: {
                                        filter: "post.type == 'text'",
                                    },
                                    image: {
                                        filter: "post.type == 'image'",
                                    },
                                    any: {
                                        filter: 'post.type',
                                    },
                                },
                                panels: [
                                    {
                                        total: 10,
                                        buckets: ['text', 2, 'image', 8, 'any', -1],
                                    },
                                ],
                            },
                        },
                        showInReplyToPost: false,
                    },
                ],
                classes: null,
                theme: {
                    colorFont: null,
                    colorPrimary: '',
                    colorSecondary: '#ff6060',
                    colorBackground: '',
                    colorNegative: '',
                    colorPostive: '',
                    ext: {
                        padding: 40,
                        gridLayoutColumns: 5,
                        gridLayoutRows: 5,
                        showGuides: false,
                        colorGrid: 'rgb(55, 55, 65)',
                        showGridLayout: false,
                        snapToGrid: false,
                        gutter: 20,
                    },
                    fontFamilyPrimary: '',
                    fontFamilySecondary: '',
                    fontSizePrimary: '',
                    fontSizeSecondary: null,
                    fontPrimary: null,
                    fontSecondary: null,
                    backgroundImage: {
                        url: '',
                        previewUrl: null,
                        samId: null,
                        name: null,
                        description: null,
                        backgroundRepeat: null,
                        backgroundSize: null,
                    },
                    typography: {
                        color: '',
                        size: null,
                        sizeLiteral: null,
                        primary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                        secondary: {
                            family: '',
                            url: '',
                            color: '',
                            size: null,
                            sizeLiteral: null,
                            samId: null,
                            name: null,
                            description: null,
                            subFamily: null,
                            weight: null,
                            style: null,
                        },
                    },
                    background: {
                        url: '',
                        size: '',
                        repeat: '',
                        color: '',
                        position: '',
                    },
                    colorPalette: {
                        type: '',
                        solid: '',
                        highlight: null,
                        monochrome: {
                            startColor: '',
                            endOffset: null,
                        },
                        colorBlend: {
                            startColor: '',
                            endColor: '',
                        },
                        ranked: {
                            colors: null,
                            contrast: null,
                        },
                    },
                },
                position: {
                    left: '2.08%',
                    right: null,
                    top: '3.72%',
                    bottom: null,
                    width: '95.84%',
                    height: '92.56%',
                    portrait: {
                        left: '3%',
                        top: '2%',
                        width: '94%',
                        height: '96%',
                    },
                    landscape: null,
                    backgroundColor: null,
                    display: null,
                    maxWidth: null,
                    maxHeight: null,
                },
                analyticsRequests: null,
                analyticsResults: null,
                profileRequests: null,
                profileResults: null,
                trendRequests: null,
                label: {
                    titleText: 'Header',
                    subTitleText: null,
                    classes: null,
                    overlap: false,
                    layout: 'flex no-grow vertical left',
                    icon: null,
                    enabled: false,
                    size: 20,
                },
            },
        ],
        id: '1',
        name: null,
        type: null,
        css: null,
        js: null,
        options: {
            player: {
                playing: false,
                duration: 15,
            },
            labelEnable: true,
            labelTimeRangeSize: 16,
            labelTimeRangeEnabled: false,
            labelTimeRangeFormat: 'Pretty Time',
            animationLength: 1000,
            animationDelay: 0,
            animationType: 'fade',
            animationEnabled: false,
            animationVariation: 6,
            widgetOrientation: 'landscape',
            opacity: 100,
            zIndex: 0,
            locked: false,
            sort: 'auto',
            percentChangeFormat: '1k',
            metricTimeRoundSeconds: false,
            fontFamilySecondary: null,
            fontFamilyPrimary: null,
            fontSize: null,
            colorFont: null,
            showSocialColors: true,
            metricThreshold: null,
            showFullTimePeriod: false,
            textFormat: '',
            useThemeColor: false,
            useThemeImage: false,
            useThemeEmail: false,
            themeEmailSize: 20,
            themeImagePosition: null,
            themeImageOpacity: 100,
            themeImageCircleMask: true,
            themeImageSize: 100,
            barChartScale: 100,
            showPostTextOverlayAsGradient: false,
            classOverrides: {},
            postVersion: 1,
            zeroFill: false,
            zeroKill: false,
            autoSizeWords: false,
            invertDataSet: false,
            showAdsMetrics: false,
        },
        userAssetContentUrl: null,
        postRequests: null,
        classes: 'template_collage',
        theme: {
            colorFont: null,
            colorPrimary: null,
            colorSecondary: null,
            colorBackground: null,
            colorNegative: null,
            colorPostive: null,
            ext: {
                padding: 0,
                gridLayoutColumns: 5,
                gridLayoutRows: 5,
                showGuides: false,
                colorGrid: 'rgb(55, 55, 65)',
                showGridLayout: false,
                snapToGrid: false,
                gutter: 20,
            },
            fontFamilyPrimary: null,
            fontFamilySecondary: null,
            fontSizePrimary: null,
            fontSizeSecondary: null,
            fontPrimary: null,
            fontSecondary: null,
            backgroundImage: null,
            typography: {
                color: '',
                size: null,
                sizeLiteral: null,
                primary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
                secondary: {
                    family: '',
                    url: '',
                    color: '',
                    size: null,
                    sizeLiteral: null,
                    samId: null,
                    name: null,
                    description: null,
                    subFamily: null,
                    weight: null,
                    style: null,
                },
            },
            background: {
                url: '',
                size: '',
                repeat: '',
                color: '',
                position: '',
            },
            colorPalette: {
                type: '',
                solid: '',
                highlight: null,
                monochrome: {
                    startColor: '',
                    endOffset: null,
                },
                colorBlend: {
                    startColor: '',
                    endColor: '',
                },
                ranked: {
                    colors: null,
                    contrast: null,
                },
            },
        },
        position: {
            left: '0',
            right: null,
            top: '0',
            bottom: null,
            width: '1920px',
            height: '1080px',
            portrait: null,
            landscape: null,
            backgroundColor: null,
            display: null,
            maxWidth: null,
            maxHeight: null,
        },
        analyticsRequests: null,
        analyticsResults: null,
        profileRequests: null,
        profileResults: null,
        trendRequests: null,
        label: {
            titleText: 'Header',
            subTitleText: null,
            classes: null,
            overlap: false,
            layout: 'flex no-grow vertical left',
            icon: null,
            enabled: false,
            size: 20,
        },
    },
    screenIndex: 0,
    sceneIndex: 0,
    dataLastModified: 1569526893235,
};
export default collageSnapshot;
